import {NgModule} from '@angular/core';
import {EmModule} from "./em/em.module";
import {HgModule} from "./hg/hg.module";
import {ImModule} from "./im/im.module";
import {FeatureIntegrationRoutingModule} from "./feature-integration.routing.module";
import {EiModule} from "./ei/ei.module";
import {HaModule} from "./ha/ha.module";
import {HbModule} from "./hb/hb.module";
import {HcModule} from "./hc/hc.module";
import {HeModule} from "./he/he.module";
import {HmModule} from "./hm/hm.module";
import {YeModule} from "./ye/ye.module";
import {EaModule} from "./ea/ea.module";
import {EeModule} from "./ee/ee.module";
// TM-1000001727: P8a — IN-Modul (Integration / Transfer)
import {InModule} from "./in/in.module";

@NgModule({
    exports: [
        EmModule,
        HgModule,
        ImModule,
        EiModule,
        HaModule,
        HbModule,
        HcModule,
        HeModule,
        HmModule,
        YeModule,
        EaModule,
        EeModule,
        // TM-1000001727: P8a
        InModule,
    ],
    imports: [
        FeatureIntegrationRoutingModule
    ]
})
export class FeatureIntegrationModule {
}